var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 5.667c0-.584-.564-1.167-1.404-1.167H7.904c-.84 0-1.404.583-1.404 1.167v12.557l5.3-2.407.102-.034a.5.5 0 0 1 .313.034l5.285 2.406zM18.5 19a.5.5 0 0 1-.707.455l-5.786-2.634-5.8 2.634A.5.5 0 0 1 5.5 19V5.667C5.5 4.41 6.64 3.5 7.904 3.5h8.192c1.263 0 2.404.91 2.404 2.167z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export default ForwardRef;